var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.756,
    height: 18.425,
    viewBox: "0 0 12.756 18.425",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-pin",
    "data-name": "Icon ionic-ios-pin",
    d: "M14.253,3.375A6.164,6.164,0,0,0,7.875,9.3c0,4.606,6.378,12.5,6.378,12.5s6.378-7.9,6.378-12.5A6.164,6.164,0,0,0,14.253,3.375Zm0,8.455A2.077,2.077,0,1,1,16.33,9.753,2.077,2.077,0,0,1,14.253,11.83Z",
    transform: "translate(-7.875 -3.375)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapIcon);
export default __webpack_public_path__ + "static/media/map-icon.2a5f475b19662f3dc4b042c1cc693f5b.svg";
export { ForwardRef as ReactComponent };